import { Record } from 'immutable';
import ErrorRecord from '~/data/ErrorRecord';

const keys: Fields = {
  isModalOpen: false,
  isInviteSent: false,
  isSubmitting: false,
  error: undefined,
};

interface Fields {
  isModalOpen: boolean;
  isInviteSent: boolean;
  isSubmitting: boolean;
  error?: ErrorRecord;
}

export default class InviteUserRecord extends Record<Fields>(keys) {}
